import { useState } from 'react'
import { mutate } from 'swr'
import { Delete_Book } from '@graphql/mutations'
import { Books_Listing } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useDeleteBook = () => {
    const [isPosting, setIsPosting] = useState(false)
    const { postMutation } = useApi()

    const post = async (data, successMessage, errorMessage) => {
        setIsPosting(true)

        const res = await postMutation(
            data,
            Delete_Book,
            successMessage ? successMessage : 'Boken är raderad.',
            errorMessage ? errorMessage : 'Nåt gick fel när boken skulle raderas.',
            async () => {
                await mutate(Books_Listing)
            }
        )

        setIsPosting(false)
        return res
    }

    return {
        post,
        isPosting,
    }
}

export { useDeleteBook }
